import React, { useEffect, useRef, useState } from "react";

import motocrossImg from "../../Assets/Works/motocross.webp";
import windsurfImg from "../../Assets/Works/windsurf.webp";
import proximidadImg from "../../Assets/Academy/M1.webp";
import spacesImg from "../../Assets/Academy/M2.webp";
import oneShotImg from "../../Assets/Works/lunasgrill.webp";
import cinematic from "../../Assets/Academy/M3.webp";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AiOutlineArrowRight } from "react-icons/ai";

export const itemsAcademy = [
   {
      title: "ACCIÓN EN ALTA VELOCIDAD",
      meta: "Seguimiento de Objetos Móviles",
      img: motocrossImg,
      vimeoId: "1193904803",
      size: "medium",
   },
   {
      title: "VUELOS DE PROXIMIDAD",
      meta: "Manejo del Entorno",
      img: proximidadImg,
      vimeoId: "1193917405",
      size: "large",
   },
   {
      title: "EXPLORACIÓN DE ESPACIOS",
      meta: "Precisión en Espacios Estrechos",
      img: spacesImg,
      vimeoId: "1193914185",
      size: "large",
   },
   {
      title: "ONE-SHOT CINEMÁTICO",
      meta: "Grabaciones One-Shot (Única Toma)",
      img: oneShotImg,
      vimeoId: "1193908138",
      size: "medium",
   },
   {
      title: "CAPTURA EN ENTORNOS CRÍTICOS",
      meta: "Condiciones de Viento y Clima",
      img: windsurfImg,
      vimeoId: "1193920760",
      size: "square",
   },
   {
      title: "VUELO CINEMÁTICO",
      meta: "Cinematic FPV",
      img: cinematic,
      vimeoId: "1194018618",
      size: "large",
   },
];

export const itemsHome = [
   {
      titleKey: "home_services.action.title",
      metaKey: "home.action.meta",
      img: motocrossImg,
      vimeoId: "1193904803",
      size: "medium",
   },
   {
      titleKey: "home_services.events.title",
      metaKey: "home_services.events.meta",
      img: proximidadImg,
      vimeoId: "1193917405",
      size: "large",
   },
   {
      titleKey: "home_services.realestate.title",
      metaKey: "home_services.realestate.meta",
      img: spacesImg,
      vimeoId: "1193914185",
      size: "large",
   },
   {
      titleKey: "home_services.oneshot.title",
      metaKey: "home_services.oneshot.meta",
      img: oneShotImg,
      vimeoId: "1193908138",
      size: "medium",
   },
   {
      titleKey: "home_services.critical.title",
      metaKey: "home_services.critical.meta",
      img: windsurfImg,
      vimeoId: "1193920760",
      size: "square",
   },
   {
      titleKey: "home_services.cinematic.title",
      metaKey: "home_services.cinematic.meta",
      img: cinematic,
      vimeoId: "1194018618",
      size: "large",
   },
];

const PortfolioItem = ({ item, cookiesAccepted, HomePage, items, t }) => {
const translatedTitle =
   item.titleKey && typeof t === "function" ? t(item.titleKey) : item.title;
const translatedMeta =
   item.metaKey && typeof t === "function" ? t(item.metaKey) : item.meta;
   const [isVisible, setIsVisible] = useState(false);
   const [videoLoaded, setVideoLoaded] = useState(false);

   const itemRef = useRef(null);

   const isMobile = window.innerWidth < 768;

   useEffect(() => {
      const observer = new IntersectionObserver(
         ([entry]) => {
            // MOBILE
            if (isMobile) {
               if (entry.isIntersecting) {
                  setIsVisible(true);
               }
               // else {
                  // destruye el iframe al salir de pantalla
                  // setIsVisible(false);
                  // setVideoLoaded(false);
               // }
            }

            // DESKTOP
            else {
               if (entry.isIntersecting) {
                  setIsVisible(true);

                  // solo carga una vez
                  observer.disconnect();
               }
            }
         },
         {
            threshold: 0.6,
         },
      );

      if (itemRef.current) {
         observer.observe(itemRef.current);
      }

      return () => observer.disconnect();
   }, [isMobile]);

   return (
      <div ref={itemRef} className={`portfolio-item ${item.size}`}>
         {/* THUMBNAIL */}
         <img
            className={`portfolio-img ${videoLoaded ? "fade-out" : ""}`}
            src={item.img}
            alt={translatedTitle}
            title={translatedTitle}
            loading="lazy"
            decoding="async"
         />

         {/* LOADER */}
         {isVisible && (
            <div className="video-loader">
               <div className="spinner"></div>
            </div>
         )}

         {/* VIDEO SOLO CUANDO ES VISIBLE */}
         {isVisible && cookiesAccepted && (
            <div className="vimeo-wrapper">
               <iframe
                  loading="lazy"
                  src={`https://player.vimeo.com/video/${item.vimeoId}?background=1&autoplay=1&muted=1&loop=1&dnt=1`}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  title={translatedTitle}
                  className="portfolio-video"
                  onLoad={() => setVideoLoaded(true)}
               />
            </div>
         )}

         {/* OVERLAY */}
         <div className="portfolio-overlay">
            <div className="portfolio-info">
               <h3>{translatedTitle}</h3>
               <p>{translatedMeta}</p>
            </div>
         </div>
      </div>
   );
};

const PortfolioV = ({ cookiesAccepted, HomePage, items }) => {

   const { t } = useTranslation();
   const location = useLocation();
   const isEnglish = location.pathname.startsWith("/en");
   const basePath = isEnglish ? "/en" : "";
   
   return (
      <section className="portfolio-section">
         <div className="portfolio-grid">
            {items.map((item, index) => (
               <PortfolioItem
                  key={index}
                  item={item}
                  cookiesAccepted={cookiesAccepted}
                  t={t}
               />
            ))}
         </div>
         {HomePage && (
            <div className="learn-more-services">
               <Link
                  to={`${basePath}/servicios-drones`}
                  className="learn-more-link"
                  title="Servicios con drones"
               >
                  {t("learn_more_services")} <AiOutlineArrowRight />
               </Link>
            </div>
         )}
      </section>
   );
};

export default PortfolioV;
